import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Overlays({ view, t, onClose }) {
  const open = view === "about";
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="overlay-about"
          initial={{ opacity: 1, clipPath: "inset(0 0 100% 0)" }}
          animate={{ opacity: 1, clipPath: "inset(0 0 0% 0)" }}
          exit={{ opacity: 0, clipPath: "inset(0 0 0% 0)" }}
          transition={{ clipPath: { duration: 0.7, ease: EASE }, opacity: { duration: 0.4 } }}
          style={{ backgroundColor: "#F7F7F5" }}
          className="fixed inset-0 z-[70] flex flex-col"
        >
          {/* top bar */}
          <div className="flex items-center justify-between px-6 md:px-12 py-6 md:py-8">
            <span className="font-display text-sm md:text-base font-medium tracking-[0.14em] text-bh-ink">
              BAUHAUS CO.
            </span>
            <button
              data-testid="overlay-close"
              onClick={onClose}
              className="group flex items-center gap-2 text-sm tracking-wide text-bh-soft hover:text-bh-ink transition-colors"
            >
              {t.close}
              <span className="text-base transition-transform duration-300 group-hover:rotate-90">✕</span>
            </button>
          </div>

          {/* content */}
          <div className="flex-1 flex flex-col justify-center px-6 md:px-12 lg:px-24 pb-16">
            <div className="max-w-3xl w-full">
              <motion.h3
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: EASE, delay: 0.25 }}
                className="font-display uppercase tracking-[0.2em] text-xs text-bh-soft mb-10"
              >
                {t.about.title}
              </motion.h3>

              <div className="space-y-7">
                {t.about.body.map((p, i) => (
                  <motion.p
                    key={i}
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: EASE, delay: 0.35 + i * 0.12 }}
                    className="font-display text-2xl md:text-4xl leading-[1.15] tracking-tight text-bh-ink"
                  >
                    {p}
                  </motion.p>
                ))}
              </div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, ease: EASE, delay: 0.7 }}
                className="mt-14 pt-8 border-t border-bh-line flex flex-wrap items-center gap-x-10 gap-y-3 text-sm"
              >
                <a
                  data-testid="overlay-contact-email"
                  href={`mailto:${t.contactPage.email}`}
                  className="text-bh-ink hover:text-bh-soft transition-colors"
                >
                  {t.contactPage.email}
                </a>
                <a
                  data-testid="overlay-contact-whatsapp"
                  href="https://wa.me/5513997003212"
                  target="_blank"
                  rel="noreferrer"
                  className="text-bh-soft hover:text-bh-ink transition-colors"
                >
                  {t.contactPage.whatsapp}
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
